import { useEffect, useState } from 'react';

export default function useIsPrinting(): boolean {
  const [isPrinting, setIsPrinting] = useState(false);

  useEffect(() => {
    function onBeforePrint() {
      setIsPrinting(true);
    }
    function onAfterPrint() {
      setIsPrinting(false);
    }
    window.addEventListener('beforeprint', onBeforePrint);
    window.addEventListener('afterprint', onAfterPrint);
    return () => {
      window.removeEventListener('beforeprint', onBeforePrint);
      window.removeEventListener('afterprint', onAfterPrint);
    };
  }, []);

  return isPrinting;
}
